var _rect, _rect2, _rect3, _g, _g2, _g3, _g4, _g5, _g6, _path, _path2, _path3, _path4, _rect4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMonolithicLambdaSmall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 289,
    height: 142,
    viewBox: "0 0 289 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2465_28768",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 283,
    height: 136
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 283,
    height: 136,
    rx: 8,
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2465_28768)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 856,
    height: 703,
    transform: "translate(-284 -311)",
    fill: "#020409"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2465_28768",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -284,
    y: -311,
    width: 856,
    height: 703
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -284,
    y: -311,
    width: 856,
    height: 703,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2465_28768)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M572 8.00021L-284 8.0002",
    stroke: "#171B21",
    strokeWidth: 2,
    strokeDasharray: "10 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572 24.0002L-284 24.0002",
    stroke: "#171B21",
    strokeWidth: 2,
    strokeDasharray: "10 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572 40.0002L-284 40.0002",
    stroke: "#171B21",
    strokeWidth: 2,
    strokeDasharray: "10 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572 56.0002L-284 56.0002",
    stroke: "#171B21",
    strokeWidth: 2,
    strokeDasharray: "10 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572 72.0002L-284 72.0002",
    stroke: "#171B21",
    strokeWidth: 2,
    strokeDasharray: "10 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572 88.0002L-284 88.0002",
    stroke: "#171B21",
    strokeWidth: 2,
    strokeDasharray: "10 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572 104L-284 104",
    stroke: "#171B21",
    strokeWidth: 2,
    strokeDasharray: "10 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572 120L-284 120",
    stroke: "#171B21",
    strokeWidth: 2,
    strokeDasharray: "10 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572 136L-284 136",
    stroke: "#171B21",
    strokeWidth: 2,
    strokeDasharray: "10 1"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 -311V418",
    stroke: "#171B21",
    strokeWidth: 2,
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 -311V418",
    stroke: "#171B21",
    strokeWidth: 2,
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 -311V418",
    stroke: "#171B21",
    strokeWidth: 2,
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 -311V418",
    stroke: "#171B21",
    strokeWidth: 2,
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 -311V418",
    stroke: "#171B21",
    strokeWidth: 2,
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 -311V418",
    stroke: "#171B21",
    strokeWidth: 2,
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112 -311V418",
    stroke: "#171B21",
    strokeWidth: 2,
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128 -311V418",
    stroke: "#171B21",
    strokeWidth: 2,
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144 -311V418",
    stroke: "#171B21",
    strokeWidth: 2,
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160 -311V418",
    stroke: "#171B21",
    strokeWidth: 2,
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176 -311V418",
    stroke: "#171B21",
    strokeWidth: 2,
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192 -311V418",
    stroke: "#171B21",
    strokeWidth: 2,
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208 -311V418",
    stroke: "#171B21",
    strokeWidth: 2,
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224 -311V418",
    stroke: "#171B21",
    strokeWidth: 2,
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240 -311V418",
    stroke: "#171B21",
    strokeWidth: 2,
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 -311V418",
    stroke: "#171B21",
    strokeWidth: 2,
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272 -311V418",
    stroke: "#171B21",
    strokeWidth: 2,
    strokeDasharray: "2 2"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2465_28768)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.8432 31H48.3762C47.8535 31.0275 47.363 31.2607 47.0119 31.6488C46.6607 32.0369 46.4775 32.5482 46.5022 33.071V45.5978C46.4775 46.1205 46.6607 46.6319 47.0119 47.0199C47.363 47.408 47.8535 47.6413 48.3762 47.6687H59.13V46.6585H48.3762C48.1254 46.6222 47.8975 46.493 47.7375 46.2966C47.5775 46.1001 47.4972 45.8507 47.5124 45.5978V37.0614H56.6045V44.638C56.6045 44.772 56.6577 44.9005 56.7524 44.9952C56.8471 45.0899 56.9756 45.1432 57.1096 45.1432H61.1505V44.1329H57.842V43.9814C57.8407 43.1383 58.1119 42.3173 58.6153 41.641C59.1187 40.9646 59.8273 40.4691 60.6353 40.2284C61.0252 40.4069 61.449 40.4993 61.8779 40.4993C62.3067 40.4993 62.7305 40.4069 63.1204 40.2284C64.052 40.5096 64.847 41.1247 65.353 41.9559L66.2117 41.4508C65.6917 40.6018 64.9277 39.9293 64.0195 39.5213C64.4339 39.0293 64.6612 38.4067 64.661 37.7635C64.661 37.0267 64.3683 36.32 63.8473 35.799C63.3263 35.278 62.6197 34.9853 61.8829 34.9853C61.1461 34.9853 60.4395 35.278 59.9185 35.799C59.3975 36.32 59.1048 37.0267 59.1048 37.7635C59.118 38.3962 59.35 39.0049 59.7614 39.4859C58.8872 39.8736 58.1461 40.5094 57.6299 41.3144V34.5358H66.2168V41.4558V41.6074H67.227V37.0614H68.7423V42.1125H69.7526V33.071C69.7648 32.8092 69.7249 32.5477 69.6352 32.3015C69.5456 32.0553 69.408 31.8293 69.2304 31.6367C69.0528 31.4441 68.8388 31.2886 68.6006 31.1793C68.3625 31.07 68.1051 31.0091 67.8432 31ZM61.8829 35.9855C62.1137 35.9841 62.3426 36.0283 62.5564 36.1154C62.7701 36.2025 62.9647 36.3309 63.1288 36.4932C63.293 36.6554 63.4236 36.8485 63.5131 37.0612C63.6027 37.274 63.6495 37.5023 63.6508 37.7332C63.6487 38.0446 63.5626 38.3497 63.4018 38.6164C63.2409 38.883 63.0111 39.1014 62.7365 39.2485C62.4735 39.3904 62.1793 39.4647 61.8804 39.4647C61.5815 39.4647 61.2873 39.3904 61.0242 39.2485C60.751 39.1003 60.5225 38.8816 60.3626 38.615C60.2027 38.3485 60.1172 38.044 60.115 37.7332C60.1163 37.5023 60.1631 37.274 60.2527 37.0612C60.3422 36.8485 60.4728 36.6554 60.637 36.4932C60.8012 36.3309 60.9957 36.2025 61.2095 36.1154C61.4232 36.0283 61.6521 35.9841 61.8829 35.9855ZM67.2118 36.0511V34.0307C67.2118 33.8967 67.1586 33.7682 67.0639 33.6735C66.9692 33.5788 66.8407 33.5256 66.7067 33.5256H57.1096C56.9756 33.5256 56.8471 33.5788 56.7524 33.6735C56.6577 33.7682 56.6045 33.8967 56.6045 34.0307V36.0511H47.5124V33.071C47.4972 32.8181 47.5775 32.5686 47.7375 32.3722C47.8975 32.1757 48.1254 32.0465 48.3762 32.0102H67.8432C68.0958 32.0442 68.3263 32.1724 68.4883 32.3691C68.6504 32.5658 68.7321 32.8165 68.7171 33.071V36.0511H67.2118Z",
    fill: "#7E858F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0789 39.5617H48.5327V40.5719H54.0789V39.5617Z",
    fill: "#7E858F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0584 42.0873H48.5327V43.0975H52.0584V42.0873Z",
    fill: "#7E858F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5841 42.0873H53.0789V43.0975H54.5841V42.0873Z",
    fill: "#7E858F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.3987 53.7554C65.7 53.7587 65.0081 53.6187 64.3657 53.3439C63.7234 53.0691 63.1442 52.6654 62.6641 52.1577C62.184 51.6501 61.8132 51.0494 61.5746 50.3927C61.336 49.736 61.2347 49.0374 61.2769 48.34C61.3192 47.6426 61.5041 46.9612 61.8202 46.3382C62.1363 45.7151 62.577 45.1635 63.1148 44.7176C63.6527 44.2716 64.2763 43.9408 64.9472 43.7455C65.618 43.5503 66.3218 43.4947 67.015 43.5824C67.9311 43.6956 68.7996 44.0547 69.528 44.6217C70.2565 45.1887 70.8179 45.9424 71.1525 46.8027C71.4871 47.6631 71.5825 48.598 71.4285 49.5082C71.2745 50.4184 70.877 51.2699 70.278 51.9723C69.805 52.5166 69.2257 52.9583 68.5758 53.2705C67.8942 53.5893 67.1511 53.7548 66.3987 53.7554ZM66.3987 44.5522C65.7499 44.5519 65.1106 44.7079 64.5349 45.0068C63.584 45.5003 62.8643 46.3466 62.5299 47.3643C62.1956 48.3821 62.2732 49.4904 62.7462 50.4516C63.2192 51.4128 64.0499 52.1504 65.0603 52.5065C66.0707 52.8625 67.1804 52.8086 68.1515 52.3562C68.676 52.1075 69.1423 51.7512 69.5203 51.3106C70.0017 50.7473 70.3213 50.064 70.4451 49.3335C70.5688 48.6029 70.4921 47.8524 70.2231 47.162C69.9541 46.4716 69.5028 45.8671 68.9174 45.4128C68.332 44.9586 67.6344 44.6716 66.8988 44.5825C66.7295 44.562 66.5591 44.5518 66.3886 44.5522H66.3987Z",
    fill: "#7E858F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5956 50.8004C65.5291 50.8008 65.4632 50.788 65.4017 50.7629C65.3402 50.7378 65.2842 50.7007 65.237 50.6539L63.6055 49.0224L64.3076 48.3102L65.5805 49.5831L68.4596 46.6989L69.1769 47.4161L65.934 50.6539C65.8437 50.7436 65.7229 50.796 65.5956 50.8004Z",
    fill: "#7E858F"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2465_28768)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.4904 111.985C64.3846 111.985 64.2814 111.952 64.1957 111.89C64.1311 111.844 64.0784 111.783 64.0419 111.713C64.0054 111.643 63.9862 111.564 63.9858 111.485V88.5048C63.9862 88.4194 64.0084 88.3356 64.0504 88.2612C64.0924 88.1869 64.1527 88.1245 64.2256 88.0801C64.2994 88.0324 64.3844 88.005 64.4721 88.0006C64.5598 87.9962 64.6471 88.015 64.7252 88.0552L71.2197 91.2275C71.303 91.2683 71.3733 91.3315 71.4227 91.41C71.4721 91.4886 71.4987 91.5793 71.4994 91.6721V109.327C71.5048 109.437 71.474 109.545 71.4117 109.635C71.3494 109.725 71.2591 109.793 71.1547 109.827L64.6603 111.985C64.6039 111.993 64.5467 111.993 64.4904 111.985ZM64.99 89.3091V110.791L70.4853 108.967V91.9818L64.99 89.3091Z",
    fill: "#7E858F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4947 111.985C53.4417 111.992 53.3879 111.992 53.3349 111.985L46.8404 109.827C46.737 109.792 46.6478 109.724 46.5865 109.634C46.5251 109.544 46.495 109.436 46.5007 109.327V91.6721C46.5014 91.5793 46.528 91.4886 46.5774 91.41C46.6268 91.3315 46.6971 91.2683 46.7804 91.2275L53.2749 88.0552C53.353 88.015 53.4403 87.9962 53.528 88.0006C53.6158 88.005 53.7008 88.0324 53.7745 88.0801C53.8465 88.1251 53.9058 88.1877 53.9469 88.262C53.988 88.3363 54.0095 88.4199 54.0093 88.5048V111.485C54.0089 111.564 53.9897 111.643 53.9532 111.713C53.9167 111.783 53.864 111.844 53.7995 111.89C53.7121 111.956 53.6043 111.99 53.4947 111.985ZM47.4998 108.987L52.9951 110.811V89.3291L47.4998 92.0118V108.987Z",
    fill: "#7E858F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9857 94.9993H62.487V94.0001H63.9857V94.9993ZM60.9882 94.9993H59.4895V94.0001H60.9882V94.9993ZM57.9908 94.9993H56.4921V94.0001H57.9908V94.9993ZM54.9934 94.9993H53.4946V94.0001H54.9934V94.9993Z",
    fill: "#7E858F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9857 105.99H62.487V104.991H63.9857V105.99ZM60.9882 105.99H59.4895V104.991H60.9882V105.99ZM57.9908 105.99H56.4921V104.991H57.9908V105.99ZM54.9934 105.99H53.4946V104.991H54.9934V105.99Z",
    fill: "#7E858F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7969 101.714L54.9185 100.11C54.8637 100.063 54.8197 100.005 54.7895 99.9392C54.7593 99.8737 54.7437 99.8024 54.7437 99.7302C54.7437 99.6581 54.7593 99.5868 54.7895 99.5212C54.8197 99.4557 54.8637 99.3975 54.9185 99.3506L56.7919 97.7469L57.4414 98.5063L56.0126 99.7452L57.4414 100.969L56.7969 101.714Z",
    fill: "#7E858F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1881 101.714L60.5387 100.954L61.9675 99.7452L60.5337 98.5263L61.1831 97.7469L63.0615 99.3456C63.1164 99.3925 63.1604 99.4507 63.1906 99.5162C63.2208 99.5818 63.2364 99.6531 63.2364 99.7252C63.2364 99.7974 63.2208 99.8687 63.1906 99.9342C63.1604 99.9998 63.1164 100.058 63.0615 100.105L61.1881 101.714Z",
    fill: "#7E858F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5064 96.8938L57.5208 102.767L58.4673 103.087L60.4529 97.2138L59.5064 96.8938Z",
    fill: "#7E858F"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_2465_28768)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.819 109.973V108.101H115.314V109.989H114.734V105.84H115.314V107.633H116.819V105.824H117.399V109.973H116.819Z",
    fill: "#7E858F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.963 109.973V106.308H117.931V105.824H120.59V106.308H119.543V109.973H118.963Z",
    fill: "#7E858F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.952 109.973V106.308H120.926V105.824H123.585V106.308H122.532V109.973H121.952Z",
    fill: "#7E858F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.665 108.362V109.957H124.101V105.808H125.319C125.526 105.803 125.73 105.86 125.904 105.973C126.075 106.082 126.212 106.237 126.298 106.42C126.389 106.628 126.434 106.853 126.431 107.08C126.448 107.422 126.332 107.758 126.106 108.016C126.006 108.129 125.882 108.218 125.743 108.278C125.604 108.338 125.454 108.366 125.303 108.362H124.665ZM124.665 107.904H125.255C125.341 107.906 125.426 107.887 125.503 107.849C125.58 107.811 125.646 107.755 125.697 107.686C125.801 107.506 125.857 107.301 125.857 107.093C125.857 106.885 125.801 106.68 125.697 106.5C125.646 106.432 125.579 106.377 125.502 106.34C125.425 106.303 125.341 106.285 125.255 106.287H124.665V107.904Z",
    fill: "#7E858F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.011 112H106.755C105.893 112 105.066 111.658 104.455 111.048C103.845 110.439 103.501 109.612 103.5 108.75V90.25C103.501 89.3885 103.844 88.5626 104.453 87.9535C105.063 87.3443 105.888 87.0014 106.75 87H125.25C126.112 87.0014 126.937 87.3443 127.547 87.9535C128.156 88.5626 128.499 89.3885 128.5 90.25V102.484H127.436V90.25C127.436 89.6702 127.206 89.1141 126.796 88.7041C126.386 88.2942 125.83 88.0638 125.25 88.0638H106.75C106.17 88.0638 105.614 88.2942 105.204 88.7041C104.794 89.1141 104.564 89.6702 104.564 90.25V108.75C104.564 109.33 104.794 109.886 105.204 110.296C105.614 110.706 106.17 110.936 106.75 110.936H111.005L111.011 112Z",
    fill: "#7E858F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.5 112H111.979V103.457H128.5V112ZM113.043 110.936H127.436V104.521H113.043V110.936Z",
    fill: "#7E858F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.5 112H125.25V110.936H127.436V108.75H128.5V112Z",
    fill: "#7E858F"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_2465_28768)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184.015 112H177.855C177.761 112 177.669 111.973 177.589 111.922C177.51 111.872 177.446 111.8 177.405 111.715L168.695 93.5H165.01C164.878 93.5 164.75 93.4473 164.657 93.3535C164.563 93.2598 164.51 93.1326 164.51 93V87.5C164.51 87.3674 164.563 87.2402 164.657 87.1464C164.75 87.0526 164.878 87 165.01 87H172.71C172.804 87.0002 172.897 87.0271 172.976 87.0776C173.056 87.128 173.12 87.1999 173.16 87.285L181.83 105.5H184.015C184.148 105.5 184.275 105.553 184.369 105.646C184.463 105.74 184.515 105.867 184.515 106V111.5C184.515 111.633 184.463 111.76 184.369 111.854C184.275 111.947 184.148 112 184.015 112ZM178.17 111H183.515V106.5H181.515C181.421 106.5 181.329 106.473 181.249 106.422C181.17 106.372 181.106 106.3 181.065 106.215L172.395 88H165.515V92.5H169.015C169.109 92.5002 169.202 92.5271 169.281 92.5776C169.361 92.628 169.425 92.6999 169.465 92.785L178.17 111Z",
    fill: "#7E858F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.505 112H161.005C160.92 112 160.837 111.979 160.762 111.938C160.688 111.896 160.625 111.837 160.58 111.765C160.532 111.691 160.505 111.606 160.501 111.518C160.496 111.431 160.515 111.343 160.555 111.265L167.355 97.06C167.396 96.9749 167.459 96.903 167.539 96.8526C167.619 96.8021 167.711 96.7752 167.805 96.775C167.899 96.7748 167.991 96.8009 168.07 96.8504C168.15 96.8999 168.214 96.9708 168.255 97.055L171.51 103.75C171.543 103.818 171.56 103.892 171.56 103.967C171.56 104.043 171.543 104.117 171.51 104.185L167.96 111.685C167.924 111.776 167.861 111.855 167.78 111.911C167.699 111.967 167.604 111.998 167.505 112ZM161.805 111H167.19L170.505 104L167.81 98.425L161.805 111Z",
    fill: "#7E858F"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_2465_28768)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M236.516 101.021L233.208 104.324C233.803 104.158 234.377 103.924 234.92 103.628C235.078 103.727 235.213 103.858 235.316 104.013C235.419 104.169 235.487 104.345 235.515 104.529C235.515 105.445 233.573 106.441 230.691 106.846C229.802 106.966 228.906 107.03 228.009 107.036H227.509C223.465 106.941 220.503 105.665 220.503 104.534C220.531 104.35 220.599 104.174 220.702 104.018C220.805 103.863 220.94 103.732 221.098 103.633C222.67 104.509 225.217 105.029 228.009 105.029H228.064L228.344 104.029C228.234 104.029 228.124 104.029 228.009 104.029C225.257 104.029 222.705 103.483 221.349 102.622C220.808 102.267 220.508 101.882 220.503 101.547V99.2298C222.034 100.401 225.087 101.011 228.009 101.011C228.404 101.011 228.8 101.011 229.185 100.976L229.47 99.9754C228.97 100.01 228.504 100.025 228.009 100.025C223.716 100.025 220.503 98.7094 220.503 97.5234C220.531 97.3392 220.599 97.1633 220.702 97.0078C220.805 96.8523 220.94 96.7209 221.098 96.6227C222.48 97.3983 224.601 97.8837 227.008 97.9938L227.033 96.993C224.666 96.8779 222.53 96.3675 221.349 95.6119C220.813 95.2666 220.513 94.8763 220.503 94.536V92.2242C222.034 93.3951 225.087 94.0056 228.009 94.0056H228.119L228.65 93.0048H228.009C223.716 93.0048 220.503 91.6888 220.503 90.5028C220.503 89.3169 223.716 88.0008 228.009 88.0008C229.455 87.9947 230.897 88.1627 232.302 88.5012H235.05C233.548 87.5855 230.956 87 228.009 87C223.886 87 219.502 88.221 219.502 90.5028V94.531C219.517 94.8164 219.592 95.0954 219.723 95.3497C219.853 95.6041 220.035 95.8281 220.258 96.0072C220.032 96.1893 219.848 96.4173 219.718 96.6762C219.588 96.9351 219.514 97.2188 219.502 97.5084V101.512C219.514 101.801 219.587 102.085 219.718 102.344C219.848 102.603 220.032 102.831 220.258 103.013C220.032 103.195 219.848 103.423 219.718 103.682C219.588 103.941 219.514 104.224 219.502 104.514V108.517C219.499 108.552 219.499 108.587 219.502 108.622C219.637 110.819 223.941 112 228.009 112C232.077 112 236.381 110.819 236.516 108.612C236.521 108.577 236.521 108.542 236.516 108.507V104.504C236.506 104.214 236.434 103.929 236.303 103.67C236.173 103.411 235.987 103.183 235.76 103.003C235.986 102.821 236.17 102.593 236.301 102.334C236.431 102.075 236.504 101.791 236.516 101.502V101.021ZM235.515 108.527C235.515 109.708 232.302 111.029 228.009 111.029C223.716 111.029 220.503 109.723 220.503 108.527V106.225C222.034 107.386 225.087 107.997 228.009 107.997C230.931 107.997 233.984 107.386 235.515 106.225V108.527Z",
    fill: "#7E858F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.004 95.1615C222.35 95.1615 222.63 94.8815 222.63 94.536C222.63 94.1906 222.35 93.9105 222.004 93.9105C221.659 93.9105 221.379 94.1906 221.379 94.536C221.379 94.8815 221.659 95.1615 222.004 95.1615Z",
    fill: "#7E858F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.004 102.167C222.35 102.167 222.63 101.887 222.63 101.542C222.63 101.196 222.35 100.916 222.004 100.916C221.659 100.916 221.379 101.196 221.379 101.542C221.379 101.887 221.659 102.167 222.004 102.167Z",
    fill: "#7E858F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.004 109.173C222.35 109.173 222.63 108.893 222.63 108.547C222.63 108.202 222.35 107.922 222.004 107.922C221.659 107.922 221.379 108.202 221.379 108.547C221.379 108.893 221.659 109.173 222.004 109.173Z",
    fill: "#7E858F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.26 106.526C229.172 106.525 229.086 106.5 229.01 106.456C228.912 106.399 228.837 106.312 228.795 106.208C228.753 106.103 228.748 105.988 228.78 105.88L231.592 96.5176H228.76C228.672 96.5187 228.586 96.4969 228.51 96.4543C228.433 96.4118 228.37 96.35 228.324 96.2751C228.279 96.2002 228.255 96.1148 228.253 96.0274C228.251 95.94 228.272 95.8537 228.314 95.777L231.317 89.7722C231.358 89.6897 231.422 89.6203 231.501 89.5717C231.579 89.5231 231.67 89.4972 231.762 89.497H238.267C238.348 89.4929 238.429 89.5087 238.503 89.5428C238.576 89.577 238.641 89.6286 238.69 89.6931C238.739 89.7576 238.772 89.8332 238.786 89.9132C238.799 89.9932 238.793 90.0753 238.768 90.1525L237.487 94.0006H240.294C240.392 94.0009 240.487 94.0299 240.569 94.084C240.65 94.1381 240.714 94.2149 240.752 94.3048C240.791 94.3948 240.802 94.494 240.784 94.5902C240.767 94.6865 240.722 94.7755 240.654 94.8462L229.645 106.355C229.597 106.41 229.538 106.454 229.472 106.483C229.405 106.512 229.333 106.527 229.26 106.526ZM229.57 95.5168H232.263C232.34 95.5168 232.417 95.5349 232.486 95.5696C232.556 95.6043 232.616 95.6548 232.663 95.7169C232.709 95.7791 232.741 95.8512 232.755 95.9277C232.769 96.0041 232.765 96.0827 232.743 96.1573L230.336 104.164L239.098 95.0064H236.766C236.684 95.0107 236.603 94.995 236.529 94.9605C236.455 94.9261 236.39 94.874 236.341 94.8088C236.291 94.7437 236.259 94.6674 236.246 94.5867C236.233 94.5059 236.239 94.4233 236.266 94.3458L237.547 90.5028H232.042L229.57 95.5168Z",
    fill: "#7E858F"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.8333 100C68.8333 101.473 70.0272 102.667 71.5 102.667C72.9728 102.667 74.1667 101.473 74.1667 100C74.1667 98.5272 72.9728 97.3333 71.5 97.3333C70.0272 97.3333 68.8333 98.5272 68.8333 100ZM100.833 100C100.833 101.473 102.027 102.667 103.5 102.667C104.973 102.667 106.167 101.473 106.167 100C106.167 98.5272 104.973 97.3333 103.5 97.3333C102.027 97.3333 100.833 98.5272 100.833 100ZM71.5 100.5H103.5V99.5H71.5V100.5Z",
    fill: "#7E858F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5 52.3333C57.0272 52.3333 55.8333 53.5272 55.8333 55C55.8333 56.4728 57.0272 57.6667 58.5 57.6667C59.9728 57.6667 61.1667 56.4728 61.1667 55C61.1667 53.5272 59.9728 52.3333 58.5 52.3333ZM58.5 84.3333C57.0272 84.3333 55.8333 85.5272 55.8333 87C55.8333 88.4728 57.0272 89.6667 58.5 89.6667C59.9728 89.6667 61.1667 88.4728 61.1667 87C61.1667 85.5272 59.9728 84.3333 58.5 84.3333ZM58 55L58 87L59 87L59 55L58 55Z",
    fill: "#7E858F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M125.833 100C125.833 101.473 127.027 102.667 128.5 102.667C129.973 102.667 131.167 101.473 131.167 100C131.167 98.5272 129.973 97.3333 128.5 97.3333C127.027 97.3333 125.833 98.5272 125.833 100ZM157.833 100C157.833 101.473 159.027 102.667 160.5 102.667C161.973 102.667 163.167 101.473 163.167 100C163.167 98.5272 161.973 97.3333 160.5 97.3333C159.027 97.3333 157.833 98.5272 157.833 100ZM128.5 100.5H160.5V99.5H128.5V100.5Z",
    fill: "#7E858F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M182.833 100C182.833 101.473 184.027 102.667 185.5 102.667C186.973 102.667 188.167 101.473 188.167 100C188.167 98.5272 186.973 97.3333 185.5 97.3333C184.027 97.3333 182.833 98.5272 182.833 100ZM214.833 100C214.833 101.473 216.027 102.667 217.5 102.667C218.973 102.667 220.167 101.473 220.167 100C220.167 98.5272 218.973 97.3333 217.5 97.3333C216.027 97.3333 214.833 98.5272 214.833 100ZM185.5 100.5H217.5V99.5H185.5V100.5Z",
    fill: "#7E858F"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 286,
    height: 139,
    rx: 9.5,
    stroke: "#2B2D31",
    strokeWidth: 3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2465_28768"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.5,
    y: 30,
    width: 25,
    height: 25,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2465_28768"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.5,
    y: 87,
    width: 25,
    height: 25,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_2465_28768"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 103.5,
    y: 87,
    width: 25,
    height: 25,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_2465_28768"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 160.5,
    y: 87,
    width: 25,
    height: 25,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_2465_28768"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 217.5,
    y: 87,
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonolithicLambdaSmall);
export default __webpack_public_path__ + "static/media/monolithic-lambda-small.81274918ccbdb7a12503ce6eb673ffc6.svg";
export { ForwardRef as ReactComponent };